import { observer } from 'mobx-react-lite'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useEffect } from 'react';
import useStore from 'reusable/mobx-store-utils';
import useWindowSize from 'reusable/hooks/useWindowSize';

export default observer(function AnnouncementGoose() {

   const announcementGooseStore = useStore(() => ({
      showHonk: false,
      honkMoved: 0
   }))

   const { width } = useWindowSize()

   const gooseContainerWidth = width - 400

   useEffect(() => {
      const honkTimeout = setTimeout(() => {
         announcementGooseStore.showHonk = true
      }, 300)

      const honkMovedInterval = setInterval(() => {
         announcementGooseStore.honkMoved += 1
      }, 250)

      // Clear timeout on unmount
      return () => {
         clearTimeout(honkTimeout)
         clearInterval(honkMovedInterval)
      }
   }, [announcementGooseStore, gooseContainerWidth])

   return (
      <Box
         sx={{
            width: `${gooseContainerWidth}px`,
            height: '30px',
            overflow: 'hidden',
            position: 'relative',
         }}
      >
         <Box sx={{ transform: 'scaleX(-1)', }}>
            <Typography
               sx={{
                  display: 'inline-block',
                  paddingLeft: '100%',
                  animation: 'move 3s linear infinite',
                  '@keyframes move': {
                     '0%': { transform: 'translate(0, 0)' },
                     '100%': { transform: 'translate(-100%, 0)' },
                  },
               }}
            >
               🪿
            </Typography>
         </Box>

         {announcementGooseStore.showHonk && (
            <Typography
               sx={{
                  position: 'absolute',
                  left: `${announcementGooseStore.honkMoved * (gooseContainerWidth / 10)}px`,
                  top: '0',
                  fontSize: '1rem',
               }}
            >
               Honk
            </Typography>
         )}
      </Box>
   )
})
